export const COMPONENT_STATUS = {
    LOADING: 'loading',
    IDLE: 'idle',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    CHECKING: 'checking',
    VALID: 'valid',
    INVALID: 'invalid'
}